import template from 'text!./ContactDetailsCompany.html';

export default {
    bindings: { contactModel: '<' },
    template: template
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/contacts/common/components/ContactDetailsCompany/index.js
// module id = 1615
// module chunks = 0